module.exports = __webpack_public_path__ + "img/welcomes-preview-text-fanli.1ca1bc4b.png";